export default "__VITE_ASSET__DWG5tEr5__"